export enum PopupDisplayMode {
    LARGE = 'DISPLAY_MODE_LARGE',
    SMALL = 'DISPLAY_MODE_SMALL'
}
